import { TelerikReportViewer } from "@progress/telerik-react-report-viewer/dist/cjs/main";

/**
 * Telerik Report Viewer initializes asynchronously (templates, Kendo, service version).
 * If the React component unmounts before that finishes, the internal perspectiveManager
 * is still a stub object and dispose() throws "perspectiveManager.dispose is not a function".
 * This happens when leaving the Dashboard quickly (e.g. opening Cases).
 */
export class SafeTelerikReportViewer extends TelerikReportViewer {
    dispose(): void {
        try {
            super.dispose();
        } catch {
            // incomplete async init
        }
    }
}
